enum UnicodeTokensForChartFormatters {
  WhiteSpace = '\u2002',
  BulletPoint = '\u25CF',
  FigureSpace = '\u2007',
  HollowBulletPoint = '\u25CB',
}

export default UnicodeTokensForChartFormatters;
